<template>
  <div class="website">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent me-3"
              @click="getData"
            >
              取消
            </button>
            <button
              type="button"
              @click="$refs.submit.click()"
              class="btn btn-light"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
      <form @submit.prevent="upDate">
        <div class="row">
          <div class="col-lg-6 mb-3">
            <div class="card">
              <div class="card-body">
                <div class="mb-3">
                  <label for="websiteName" class="form-label required"
                    >網站名稱</label
                  >
                  <input
                    v-model="form.title"
                    type="text"
                    class="form-control"
                    id="websiteName"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label for="websiteDescription" class="form-label required"
                    >網站介紹</label
                  >
                  <textarea
                    v-model="form.description"
                    class="form-control"
                    id="websiteDescription"
                    rows="3"
                    required
                  ></textarea>
                  <div class="form-text">
                    {{ form.description ? form.description.length : 0 }}
                    / 160
                  </div>
                  <div class="form-text">
                    用於 SEO Description，建議中文字數控制在 80
                    字以內，英文字數控制在 160 字以內。
                  </div>
                </div>
                <div class="mb-3">
                  <label for="websiteKeyword" class="form-label required"
                    >關鍵字</label
                  >
                  <div class="form-text mb-3">
                    用於 SEO Keyword，最多添加 5 項。
                  </div>
                  <div>
                    <button
                      type="button"
                      @click="form.keywords.splice(index, 1)"
                      class="btn btn-primary rounded-pill me-2 mb-2 pe-3"
                      v-for="(keywords, index) in form.keywords"
                      :key="keywords + index"
                    >
                      {{ keywords }} <i class="bi bi-x ps-2"></i>
                    </button>
                  </div>
                  <button
                    type="button"
                    @click="showKeywordsModal"
                    v-show="form.keywords && form.keywords.length < 5"
                    class="btn btn-outline-primary mt-2"
                    :class="{ 'is-invalid': invalid.keywords }"
                  >
                    <i class="bi bi-plus"></i> 新增關鍵字...
                  </button>
                  <div class="invalid-feedback" v-show="invalid.keywords">
                    {{ invalid.keywords }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mb-3">
            <div class="card" style="height: 100%">
              <div class="card-body">
                <div class="mb-3 overflow-auto">
                  <h6 class="form-label required">LOGO-Light</h6>
                  <div class="float-end">
                    <div class="imgBox-has-close">
                      <button
                        v-if="form['logo-light']"
                        @click="removeImage('logo-light')"
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                      />
                      <div class="imgBox ms-2" style="width: 120px">
                        <div class="imgBox-inner">
                          <div class="imgBox-fit">
                            <img
                              v-if="form['logo-light']"
                              :src="form['logo-light']"
                              alt=""
                            />
                            <i v-else class="bi bi-image"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-text mb-3">
                    用於亮色背景，建議寬度大於400
                    pixels、背景透明，圖片格式：JPG、PNG。
                  </div>
                  <div class="mb-3">
                    <label
                      for="formFileLogoLight"
                      class="btn btn-outline-primary"
                      :class="{ 'is-invalid': invalid.logoLight }"
                      ><i class="bi bi-image"></i> 上傳圖片</label
                    >
                    <input
                      class="form-control d-none"
                      type="file"
                      id="formFileLogoLight"
                      accept="image/png, image/jpeg"
                      @change="onFileChange('logoLight')"
                      ref="formFileLogoLight"
                    />
                    <div class="invalid-feedback" v-show="invalid.logoLight">
                      {{ invalid.logoLight }}
                    </div>
                  </div>
                </div>
                <div class="mb-3 overflow-auto">
                  <h6 class="form-label required">LOGO-Dark</h6>
                  <div class="float-end">
                    <div class="imgBox-has-close">
                      <button
                        v-if="form['logo-dark']"
                        @click="removeImage('logo-dark')"
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                      />
                      <div class="imgBox ms-2" style="width: 120px">
                        <div class="imgBox-inner">
                          <div class="imgBox-fit">
                            <img
                              v-if="form['logo-dark']"
                              :src="form['logo-dark']"
                              alt=""
                            />
                            <i v-else class="bi bi-image"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-text mb-3">
                    用於暗色背景，建議寬度大於400
                    pixels、背景透明，圖片格式：JPG、PNG。
                  </div>
                  <div class="mb-3">
                    <label
                      for="formFileLogoDark"
                      class="btn btn-outline-primary"
                      :class="{ 'is-invalid': invalid.logoDark }"
                      ><i class="bi bi-image"></i> 上傳圖片</label
                    >
                    <input
                      class="form-control d-none"
                      type="file"
                      id="formFileLogoDark"
                      accept="image/png, image/jpeg"
                      @change="onFileChange('logoDark')"
                      ref="formFileLogoDark"
                    />
                    <div class="invalid-feedback" v-show="invalid.logoDark">
                      {{ invalid.logoDark }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button ref="submit" type="submit" class="d-none"></button>
        <div class="text-end mb-3">
          <button type="button" class="btn btn-secondary me-3" @click="getData">
            取消
          </button>
          <button
            type="button"
            @click="$refs.submit.click()"
            class="btn btn-gradient"
          >
            儲存
          </button>
        </div>
      </form>
    </div>
    <KeywordsModal @setKeywords="addKeywords" :keywords="form.keywords" />
  </div>
</template>

<script>
import { website } from '@/http/api/website.js'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import KeywordsModal from '@/components/modal/KeywordsModal.vue'

const defaultInvalidDate = {
  modalKeywords: null,
  keywords: null,
  logoLight: null,
  logoDark: null
}

export default {
  name: 'Website',
  components: {
    Title,
    Breadcrumb,
    KeywordsModal
  },
  data () {
    return {
      bootstrap_modal: null,
      errMsg: null,
      errMsgKey: {
        title: '網站名稱',
        description: '網站介紹',
        keywords: '關鍵字',
        'logo-light': 'LOGO-Light',
        'logo-dark': 'LOGO-Dark'
      },
      form: {
        title: null,
        description: null,
        keywords: null,
        'logo-light': null,
        'logo-dark': null
      },
      invalid: JSON.parse(JSON.stringify(defaultInvalidDate)),
      invalidTimeout: null
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.getData()
      }
    },
    invalid: {
      handler (data) {
        const vm = this
        if (vm.invalidTimeout) {
          clearTimeout(vm.invalidTimeout)
          vm.invalidTimeout = null
        }
        vm.invalidTimeout = setTimeout(() => {
          vm.invalid = JSON.parse(JSON.stringify(defaultInvalidDate))
        }, 5000)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleKeywordsModal'
    ]),
    ...mapActions(['uploadImage']),
    addKeywords (data) {
      const vm = this
      vm.form.keywords = data
    },
    getData () {
      const vm = this
      vm.Loading()
      website
        .get(vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.form = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    invalidMessage () {
      const vm = this
      if (!vm.form.keywords || !vm.form.keywords.length) {
        vm.invalid.keywords = '關鍵字為必填'
        vm.AlertsInfo({
          state: 'error',
          title: '失敗',
          info: '有必填資料未填寫'
        })
        vm.Alerted()
        return true
      }
      if (!vm.form['logo-light']) {
        vm.invalid.logoLight = 'Logo為必填'
        vm.AlertsInfo({
          state: 'error',
          title: '失敗',
          info: '有必填資料未填寫'
        })
        vm.Alerted()
        return true
      }
      if (!vm.form['logo-dark']) {
        vm.invalid.logoDark = 'Logo為必填'
        vm.AlertsInfo({
          state: 'error',
          title: '失敗',
          info: '有必填資料未填寫'
        })
        vm.Alerted()
        return true
      }
    },
    onFileChange (type) {
      const vm = this
      const $file = type === 'logoDark' ? vm.$refs.formFileLogoDark : vm.$refs.formFileLogoLight
      vm.uploadImage($file)
        .then((value) => {
          if (value) {
            type === 'logoDark'
              ? (vm.form['logo-dark'] = value)
              : (vm.form['logo-light'] = value)
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    removeImage (type) {
      const vm = this
      type === 'logo-light'
        ? (vm.form['logo-light'] = null)
        : (vm.form['logo-dark'] = null)
    },
    showKeywordsModal () {
      const vm = this
      vm.ToggleKeywordsModal(true)
    },
    upDate () {
      const vm = this
      if (vm.invalidMessage()) return
      vm.Loading()
      website
        .update(vm.form, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
